import { useTranslation } from 'react-i18next';

import type { LogLine } from 'src/types/content';
import { useInView } from 'src/hooks/use-in-view';
import { mergeClasses } from 'src/utils/merge-classes';

const TONE_CLASS: Record<string, string | undefined> = {
  ok: 'log-ok',
  dawn: 'log-dawn',
};

type NightLogProps = {
  lines: LogLine[];
};

export function NightLog({ lines }: NightLogProps) {
  const { t } = useTranslation('common');
  const { ref, inView } = useInView<HTMLElement>(0.3);

  return (
    <figure ref={ref} className={mergeClasses('console', inView && 'visible')}>
      <figcaption className="visually-hidden">{t('labels.nightLogAlt')}</figcaption>
      <div className="console-bar">
        <i />
        <i />
        <i />
        <span>{t('labels.nightLogTitle')}</span>
      </div>
      <div className="console-body">
        {lines.map((line) => (
          <div
            key={`${line.time}-${line.text}`}
            className={mergeClasses('log-line', TONE_CLASS[line.tone])}
          >
            <span className="log-time">{line.time}</span>
            <span className="log-text">{line.text}</span>
          </div>
        ))}
        <div className="log-line">
          <span className="log-time">&nbsp;</span>
          <span className="log-cursor" />
        </div>
      </div>
    </figure>
  );
}
